import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

/**
 * Component that displays a horizontal roll of loading skeleton thumbnails
 * while thumbnails are being fetched.
 */
export function ThumbnailsLoading() {
  const { $t } = useIntl();
  const skeletonCount = 20;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '1px',
        height: '100%',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1000,
          backgroundColor: '#eee',
          padding: '2px 10px',
          borderRadius: '8px',
        }}
      >
        <small className={'text-muted'}>
          {$t({
            id: 'stream.thumbnails.loading',
            defaultMessage: 'Cargando miniaturas',
          })}
        </small>
      </Box>
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <Skeleton
          key={index}
          width={200}
          height={81}
          borderRadius="0"
          style={{ flexShrink: 0 }}
          baseColor="#f3f3f3"
          highlightColor="#fafafa"
          containerClassName="react-skeleton-flex-fix"
        />
      ))}
    </Box>
  );
}
